import React, { Component } from 'react';
import 'ol/ol.css';
import '../../map/Map.css';
import OlMap from 'ol/Map';
import OlView from 'ol/View';
import { defaults as defaultControls } from 'ol/control';
import { toLonLat } from 'ol/proj';
import {
  zoomSlider, scaleLine, attribution, mousePosition,
} from '../../map/MapControls';
import { vectorDraw, OSM } from '../../map/MapLayers';
import { interactionDraw } from '../../map/MapInteractions';
import { Button, Segment, Grid, Form, Breadcrumb, Message } from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { withRouter, Link } from 'react-router-dom';
import { ProjectInnerForm } from './ProjectInnerForm';
import apiRequest from '../../../app/common/api/apiClient';

var arrDraw = [];

const EMPTY_VALUES = {
  ref_kazu: '',
  name: '', status: 'ongoing_without_tribunal_level_community',
  municipality: '', postu: '', suku: '', aldeia: '',
  areatype: [], landtype: [],
  yearstart: '', actors: [], conflictarea: '',
  boundary_east: '', boundary_west: '', boundary_north: '', boundary_south: '',
  impactedhouseholds: '', impactedfamilymembers: '', impactedwomen: '',
  impactedyouth: '', impacteddisabled: '', impactedelderly: '',
  legalstatusfarmerspov: [], conflicthistory: '',
  legalstatusotherpov: [], ownershipproffotherpov: '',
  secondaryactors: [], juridicsituationclaming: '',
  ksisupportstart: '',
  ksisupporttype: [],
  additionalinformation: '',
  informant_name: '', informant_org: '', informant_position: '', informant_contact: '',
  enumerator_name: '', enumerator_org: '', enumerator_position: '', enumerator_contact: '',
  parte_interesada_tipo: [], parte_interesada_individu: '',
};

class ProjectsNew extends Component {
  state = { center: [13900305.064, -1085431.521], zoom: 8, action: null, error: null };

  componentDidMount() {
    const olmap = this.olmap;
    olmap.setTarget('map');
    olmap.on('moveend', () => {
      this.setState({ center: olmap.getView().getCenter(), zoom: olmap.getView().getZoom() });
    });
  }

  componentWillUnmount() {
    this.olmap.un('moveend', () => {});
  }

  olmap = new OlMap({
    target: null,
    controls: defaultControls({ attribution: false }).extend([
      zoomSlider, scaleLine, attribution, mousePosition,
    ]),
    layers: [OSM, vectorDraw],
    view: new OlView({ projection: 'EPSG:3857', center: [13900305.064, -1085431.521], zoom: 8 }),
  });

  doDraw = () => {
    arrDraw.length = 0;
    vectorDraw.getSource().clear();
    this.setState({ action: 'add' });
    this.olmap.addInteraction(interactionDraw);
    interactionDraw.once('drawend', (e) => {
      vectorDraw.getSource().clear();
      arrDraw.length = 0;
      arrDraw.push(e.feature);
      this.olmap.removeInteraction(interactionDraw);
    });
  };

  doClear = () => {
    arrDraw.length = 0;
    vectorDraw.getSource().clear();
    this.setState({ action: null });
  };

  render() {
    const validationSchema = Yup.object().shape({
      name: Yup.string().required('Títulu kazu nesesáriu'),
    });

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Breadcrumb>
              <Breadcrumb.Section as={Link} to='/cases'>Cases</Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>Kazu foun</Breadcrumb.Section>
            </Breadcrumb>
          </Grid.Column>
        </Grid.Row>

        {/* MAP */}
        <Grid.Row>
          <Grid.Column width={16}>
            <Segment>
              <div
                id='map'
                style={{ position: 'relative', top: '-37px', width: '100%', height: '400px' }}
              >
                <Button.Group style={{ position: 'relative', top: '5rem', left: '1rem', zIndex: '1' }}>
                  {this.state.action === 'add' ? (
                    <Button content='Hahu fali' onClick={this.doClear.bind(this)} />
                  ) : (
                    <Button primary icon='map marker alternate' content='Hili GPS Point' onClick={this.doDraw.bind(this)} />
                  )}
                </Button.Group>
              </div>
            </Segment>
          </Grid.Column>
        </Grid.Row>

        {/* FORM */}
        <Grid.Row>
          <Grid.Column width={16}>
            <Formik
              initialValues={EMPTY_VALUES}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                this.setState({ error: null });

                let lon = null;
                let lat = null;
                if (arrDraw.length > 0) {
                  const coords = arrDraw[0].getGeometry().getCoordinates();
                  const lonLat = toLonLat(coords, 'EPSG:3857');
                  lon = lonLat[0];
                  lat = lonLat[1];
                }

                // Serialize array fields to comma-separated strings
                const payload = { ...values, lon, lat };
                ['areatype','landtype','actors','legalstatusfarmerspov',
                 'legalstatusotherpov','secondaryactors','ksisupporttype','parte_interesada_tipo'].forEach(k => {
                  if (Array.isArray(payload[k])) payload[k] = payload[k].join(',');
                });

                apiRequest('/api/cases', {
                  method: 'POST',
                  body: JSON.stringify(payload),
                })
                  .then(async (res) => {
                    const data = await res.json();
                    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
                    return data;
                  })
                  .then((data) => {
                    arrDraw.length = 0;
                    vectorDraw.getSource().clear();
                    this.props.history.push(`/cases/${data.id}`);
                  })
                  .catch((err) => {
                    this.setState({ error: err.message });
                    setSubmitting(false);
                  });
              }}
            >
              {(formik) => (
                <Form onSubmit={formik.handleSubmit}>
                  {this.state.error && (
                    <Message negative>
                      <Message.Header>Error</Message.Header>
                      <p>{this.state.error}</p>
                    </Message>
                  )}
                  <ProjectInnerForm formik={formik} />
                  <Segment basic>
                    <Button
                      primary
                      size='large'
                      content='Rejista kazu'
                      type='submit'
                      disabled={formik.isSubmitting || !formik.isValid}
                      loading={formik.isSubmitting}
                    />
                  </Segment>
                </Form>
              )}
            </Formik>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withRouter(ProjectsNew);
